import React, { useEffect, useId, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Breadcrumb, Col, Form, Row } from "react-bootstrap";
import classes from "./FormatEdit.module.css";
import Graybg from "../../../UI/Graybg";
import Card from "../../../UI/Card/Card";
import Select from "../../../UI/Select/Select";
import SecBTN from "../../../UI/SecBTN";
import AddDeleteTableRows from "../../../Components/AddDeleteTableRow/AddDeleteTableRows";
import SuccessModal from "../../../UI/SuccessModal/SuccessModal";
import ConfirmationModal from "../../../UI/ConfirmationModal/ConfirmationModal";
import Input from "../../../UI/Input/Input";
import Loader from "../../../UI/loader/loader";
import userService from "../../../app/services/user.service";
import {isEmpty} from '../../../utils/custom_funtions'
import { toast } from "react-toastify";
import Toast from "../../../UI/Toast/Toast";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

const FormatEdit = () => {
  //we used params to conditionally render the editformat
  const { formatid } = useParams();
  const id = useId();
  const form = useRef(null)
  const uid = JSON.parse(localStorage.getItem("user"))?.data?.user?.user_id;
  const [loading, setLoading] = useState(false);
  const [subList, setSubList] = useState([])
  const [dataList, setDataList] = useState({
    target:[],
    questiontype:[],
    section:[],
  });
  const [showPopUp1, setShowPopUp1] = useState(false);
  const [showPopUp2, setShowPopUp2] = useState(false);
  const fetchFormatData = (subjectList) => {
    userService.getFormatById(formatid)
    .then(res => {
      console.log(res.data.data)
      const datas = res.data.data;
      const details = datas.details;
      const newArr = details.map(item => {
        const index = subjectList.findIndex(p => p.sub_id == item.sub_id);
        const subjectname = subjectList[index].sub_name
        return {
          ...item,
          subjectname: subjectname,
          attempt_question:item.attemp_questions,
        }
      })
      setReqData(prev => {
        return {
          ...prev,
          ...datas,
          details: newArr,
          numbering_type: datas.numbering_type ? String(datas.numbering_type) : (datas.number_sequence ? String(datas.number_sequence) : ''),
        }
      })
    })
    .catch(err => {
      console.log(err);
    })
  }
  const removeDuplicates = (originalArray, prop) => {
    let newArray = [];
    let lookupObject = {};

    for (let i in originalArray) {
      lookupObject[originalArray[i][prop]] = originalArray[i];
    } 

    for (let i in lookupObject) {
      newArray.push(lookupObject[i]);
    }
    return newArray;
  };
  const [reqData, setReqData] = useState({
    paper_format: "",
    target_id: "",
    total_questions: 0,
    active: 1,
    duration_mins: "",
    page_space_status: 0,
    numbering_type:0,
    number_sequence:0,
    instructions_image: "",
    selectedSubjectList: [
      // {sub_id:'',subjectname:''}
    ],
    details: [
      {
        sub_id:'',
        section_id:'',
        type_id:'',
        subjectname:'',
        num_questions:'',
        positive_marks:'',
        negative_marks:'',
        partial_marks:'',
        user_id: uid,
        section_instruction: "",
      }
    ],
  });
  const [totalQues,setTotalQues] = useState(0)
  const [totalMarks,setTotalMarks] = useState(0)
  useEffect(() => {
    const getData = setTimeout(() => {
        setTotalQues(() => {
          return sumArray(reqData.details,'num_questions')
        })
        const newArr = reqData.details.map((data) => {
          if (!isEmpty(data.positive_marks) && !isEmpty(data.positive_marks)) {
            return +data.num_questions * +data.positive_marks;
          } else {
            return 0;
          }
        });
        setTotalMarks(() => {
          return sumArray(newArr)
        })
    }, 2000)

    return () => clearTimeout(getData)
  }, [reqData.details])
  const addTableRows = () => {
    const rowsInput = {
      sub_id:'',
      section_id:'',
      subjectname:'',
      type_id:'',
      num_questions:'',
      positive_marks:'',
      negative_marks:'',
      partial_marks:'',
      user_id: uid,
      section_instruction: "",
    };
    setReqData(prev => {
      return {
        ...prev,
        // selectedSubjectList:[...prev.selectedSubjectList,{sub_id:'',subjectname:''}],
        details:[...prev.details, rowsInput]
      }
    });
  };
  const deleteTableRows = (index) => {
    const rows = [...reqData.details];
    rows.splice(index, 1);
    setReqData(prev => {
      return {
        ...prev,
        details:rows
      }
    })
  };

  const handleChange = (evnt) => {
    const { name, value, type } = evnt.target;
    const input = { ...reqData };
    if (type == "checkbox") {
      input[name] = evnt.target.checked ? 1 : 0;
      setReqData(input);
      return;
    } else {
      if(!isEmpty(value)){
        evnt.target.style.border = "none"
      } else {
        evnt.target.style.border = "1px solid red"
      }
    }
    if (type == "number" && value.length >3) {
      return;
    }
    input[name] = value;
    setReqData(input);
  };
  const handleRowChange = (index, evnt) => {
    const { name, value, type } = evnt.target;
    const rowsInput = [...reqData.details];
    if (type == "number" && value.length >3) {
      return;
    }
    if(!isEmpty(value)){
      evnt.target.style.border = "none"
    } else {
      evnt.target.style.border = "1px solid red"
    }
    if(name === "sub_id"){
      // const subjectList = [...reqData.selectedSubjectList];
      const nodes = [...evnt.target.childNodes]
      const indexes = nodes.findIndex(item => item.value == value);
      rowsInput[index]["subjectname"] = nodes[indexes].innerHTML;  
      rowsInput[index][name] = value;
      // subjectList.push({sub_id:value,subjectname:nodes[indexes].innerHTML})
      // const newSelectedSubjectList = removeDuplicates(subjectList, "sub_id")
      const newSelectedSubjectList = rowsInput.map(item => { return {sub_id:item.sub_id,subjectname:item.subjectname}})
      setReqData(prev => {
        return {
          ...prev,
          // selectedSubjectList:newSelectedSubjectList.filter((el) =>toRemove.includes(el.sub_id)),
          selectedSubjectList:removeDuplicates(newSelectedSubjectList, "sub_id"),
          details:rowsInput
        }
      })
    } else {
      rowsInput[index][name] = value;
      setReqData(prev => {
        return {
          ...prev,
          details:rowsInput
        }
      })
    }
    
  };
  
 
  const onSubmitHandler = (e) => {
    e.preventDefault();
    setShowPopUp1(true);
  };
  const getCommonData = () => {
    setLoading(true)
    userService.getCommonList()
    .then(data => {
      setDataList(prev => {
        return {
          ...prev,
          target:data.data.data.target,
          questiontype:data.data.data.questiontype,
          section:data.data.data.section,
        };
      })
      setLoading(false)
    })
    .catch(err => {
      console.log(err)
      setLoading(false)
    })
  }
  const getSubjectList = () => {
    setLoading(true)
    userService.getSubjectList()
    .then(data => {
      setSubList(data.data.data)
      setLoading(false)
      if (formatid !== 0) {
        fetchFormatData(data.data.data);
      }
    })
    .catch(err => {
      console.log(err)
      setLoading(false)
    })
  }
  const handleImageUpload = (type, index = "") => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.onchange = (event) => {
      if (event.target.files && event.target.files[0]) {
        handleFileChange(event, type, index);
      }
    };
    input.click();
  }
  useEffect(() => {
    getCommonData();
    getSubjectList();
    // getFileList();
    
  },[])

  const yesHandler = () => {
    // Validation: attempt_question * positive_marks sum must equal total_marks
    let attemptSum = 0;
    let attemptGreaterThanTotal = false;
    reqData.details.forEach(row => {
      const attempt = Number(row.attempt_question) || 0;
      const pos = Number(row.positive_marks) || 0;
      const numQ = Number(row.num_questions) || 0;
      attemptSum += attempt * pos;
      if (attempt > numQ) {
        attemptGreaterThanTotal = true;
      }
    });
    if (attemptGreaterThanTotal) {
      toast.error('Attempt Question should not be greater than Total Questions in any row.');
      return;
    }
    if (Number(reqData.total_marks) !== attemptSum) {
      toast.error('Sum of (Attempt Question × +ve Marks) for all rows must be equal to Total Marks.');
      return;
    }
    const body = {
      ...reqData,
      sub_seq:reqData.selectedSubjectList.map(sub => sub.sub_id).join(','),
      total_questions:reqData.total_questions,
      total_marks: reqData.total_marks,
      numbering_type: reqData.numbering_type,
      number_sequence:parseInt(reqData.number_sequence),
      created_on: new Date(),
      created_by: uid,
    }
    if(formatid == 0){
      userService.createFormat(body)
      .then(res => {
        console.log(res)
        setShowPopUp1(false);
        setShowPopUp2(true);
      })
      .catch(err => {
        console.log(err)
        console.log(err.response.data.message)
        setShowPopUp1(false);
        toast.error(err.response.data.message)
      })
    } else {
      userService.updateFormat(body)
      .then(res => {
        console.log(res)
        setShowPopUp1(false);
        setShowPopUp2(true);
      })
      .catch(err => {
        console.log(err)
        console.log(err.response.data.message)
        setShowPopUp1(false);
        toast.error(err.response.data.message)
      })
    }
    
    
  };
  const onHideHandler = () => {
    setShowPopUp1(false);
    setShowPopUp2(false);
  };
  const navigate = useNavigate()
  const onHideHandler2 = () => {
    setShowPopUp2(false);
    navigate('/paperFormat')
  };
  
  function sumArray(array,el){
    let sum = 0;
    for (let i = 0; i<array.length; i += 1) {
      if(el){
      sum += +array[i][el]
    } else {
      sum += +array[i]
    }
    }
    return sum
  }
  

  function handleFileChange(event, type, index = "") {
    const file = event.target.files[0];
    if (!file) return;

    // Create a preview URL for immediate display
    const previewUrl = URL.createObjectURL(file);
    
    // Show preview immediately
    if(type === "instructions_image"){
      setReqData(prev => {
        return {
          ...prev,
          instructions_image: previewUrl 
        }
      })
    } else {
      const rowsInput = [...reqData.details];
      rowsInput[index]["section_instruction"] = previewUrl;
      setReqData(prev => {
        return {
          ...prev,
          details:rowsInput
        }
      })
    }

    // Upload file to server
    const formData = new FormData();
    formData.append("file", file);
    console.log(formData);
    setLoading(true);
    userService
      .uploadFile(formData)
      .then((response) => {
        console.log(response.data);
        // Replace preview URL with server URL
        if(type === "instructions_image"){
          setReqData(prev => {
            return {
              ...prev,
              instructions_image: "https://cdnqms.motion.ac.in/uploads/"+response.data.location?.split('/').pop() 
            }
          })
        } else {
          const rowsInput = [...reqData.details];
          rowsInput[index]["section_instruction"] = "https://cdnqms.motion.ac.in/uploads/"+response.data.location?.split('/').pop();
          setReqData(prev => {
            return {
              ...prev,
              details:rowsInput
            }
          })
        }
        setLoading(false);
        toast.success('Image uploaded successfully!');
      })
      .catch((error) => {
        console.error("Error uploading file: ", error);
        setLoading(false);
        toast.error('Something went wrong!!')
        // Revert to empty on error
        if(type === "instructions_image"){
          setReqData(prev => {
            return {
              ...prev,
              instructions_image: ""
            }
          })
        } else {
          const rowsInput = [...reqData.details];
          rowsInput[index]["section_instruction"] = "";
          setReqData(prev => {
            return {
              ...prev,
              details:rowsInput
            }
          })
        }
      });
  }
  const onDragEnd = (result) => {
    const newItems = Array.from(reqData.selectedSubjectList);
    const [removed] = newItems.splice(result.source.index, 1);
    newItems.splice(result.destination.index, 0, removed);
    // setItems(newItems);
    setReqData(prev => {
      return {
        ...prev,
        selectedSubjectList:newItems,
      }
    })
  };
  return (
    <>
      <Toast />
      {loading && <Loader />}
      <ConfirmationModal
        title="Are you sure you want to save paper Format?"
        show={showPopUp1}
        onHide={onHideHandler}
        yesHandler={yesHandler}
        confirmTxt="yes"
      />
      <SuccessModal
        show={showPopUp2}
        onHide={onHideHandler2}
        title={`Paper Format ${
          formatid == 0 ? "Created" : "Updated"
        } Successfully!`}
        btnTxt="Ok"
      />
      <div className="section">
        <h4>Paper Format</h4>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/paperFormat"> Paper Format </Link>
          </Breadcrumb.Item>
          {/* {newFormat == 0 && (
            <Breadcrumb.Item active>
              {activate == 1 ? "Activate" : "De-activate"}
            </Breadcrumb.Item>
          )} */}
          <Breadcrumb.Item active>
            {formatid == 0 ? "Add New Format" : "Edit"}
          </Breadcrumb.Item>
        </Breadcrumb>
        <form ref={form} onSubmit={onSubmitHandler}>
          <Graybg>
            <h5 className="mb-2">Edit Basic Details</h5>
            <Card>
              <Row className="g-3">
                <Col lg={6} md={6} sm={12}>
                  <Form.Label htmlFor={id + "paper_format"}>
                    Paper Format Name :
                  </Form.Label>
                  <Input
                    id={id + "paper_format"}
                    required
                    placeholder="Enter Format name"
                    name="paper_format"
                    type="text"
                    value={reqData.paper_format}
                    onChange={handleChange}
                  />
                </Col>
                {/* <Col lg={6} md={6} sm={12}>
                <Form.Label htmlFor={id + "total_questions"}>
                  Number Of Questions :
                </Form.Label>
                <Input
                  id={id + "total_questions"}
                  required
                  placeholder="Number of questions"
                  name="total_questions"
                  type="number"
                  value={reqData.total_questions}
                  onChange={handleChange}
                />
              </Col> */}
                <Col lg={6} md={6} sm={12}>
                  <Form.Label htmlFor={id + "target_id"}>Target :</Form.Label>
                  <Select
                    id={id + "target_id"}
                    value={reqData.target_id}
                    name="target_id"
                    required
                    onChange={handleChange}
                  >
                    <option value="" disabled>
                      Select Target
                    </option>
                    {dataList.target.map((target) => {
                      return (
                        <option
                          key={id + target.target_id + target.target}
                          value={target.target_id}
                        >
                          {target.target}
                        </option>
                      );
                    })}
                  </Select>
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <Form.Label htmlFor={id + "duration_mins"}>
                    Paper Duration (In Minutes eg : 30) :
                  </Form.Label>
                  <Input
                    id={id + "duration_mins"}
                    required
                    placeholder="Paper Duration"
                    name="duration_mins"
                    type="number"
                    value={reqData.duration_mins}
                    onChange={handleChange}
                  />
                </Col>
                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    name="page_space_status"
                    label="Space for rough work"
                    checked={reqData.page_space_status == 1 ? true : false}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Row>
              {/*  */}
              {((reqData.selectedSubjectList.length === 1 && reqData.selectedSubjectList[0].sub_id == '') || isEmpty(reqData.selectedSubjectList)) ? 
              "" :
              <>
              <h5 className="mb-3">Sequence of subjects:</h5>
              <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="droppable">
                  {(provided) => (
                    <div
                    style={{height: 47*(reqData.selectedSubjectList.length+1)+"px"}}
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                    >
                      {reqData.selectedSubjectList.map((item, index) => (
                        <Draggable
                          key={JSON.stringify(item)}
                          draggableId={JSON.stringify(item)}
                          index={index}
                        >
                          {(provided, snapshot) => (
                            <div
                              className={`d-flex gap-4 align-items-center border px-2 ${classes.dragItem}`}
                              ref={provided.innerRef}
                              snapshot={snapshot}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            >
                              <i className="fa-solid fa-grip-vertical"></i>
                              <div>{index+1}. {item.subjectname}</div>
                            </div>
                          )}
                        </Draggable>
                      ))}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
              </>
              }
              {/* Add total questions and marks fields here */}
              <Row className="mb-3">
                <Col lg={6} md={6} sm={12}>
                  <Form.Label>Total Number of Questions</Form.Label>
                  <Input
                    type="number"
                    name="total_questions"
                    value={reqData.total_questions}
                    onChange={handleChange}
                  />
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <Form.Label>Total Marks</Form.Label>
                  <Input
                    type="number"
                    name="total_marks"
                    value={reqData.total_marks || ''}
                    onChange={handleChange}
                  />
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <Form.Label>Numbering Type</Form.Label>
                  <Select
                    name="number_sequence"
                    value={reqData.number_sequence || ''}
                    onChange={handleChange}
                    required
                  >
                    <option value="" disabled>Select Numbering Type</option>
                    <option value="1">Continues</option>
                    <option value="2">Section Wise</option>
                    <option value="3">Subject Wise</option>
                  </Select>
                </Col>
              </Row>
              

              {isEmpty(reqData.instructions_image) ? (
                <div className={classes["btn-section"]}>
                  <SecBTN
                    className={classes["sec-btn"]}
                    onClick={() => handleImageUpload("instructions_image")}
                    type="button"
                  >
                    <i className="bx bx-plus"></i>
                  </SecBTN>
                  <p>Add Image</p>
                </div>
              ) : (
                <div className="text-center">
                  <div className={classes.instructionsImg}>
                    <img src={reqData.instructions_image} />
                    <i
                      className="fa-solid fa-xmark"
                      onClick={() => {
                        setReqData((prev) => {
                          return {
                            ...prev,
                            instructions_image: "",
                          };
                        });
                      }}
                    ></i>
                  </div>
                </div>
              )}
            </Card>
            <h5 className="mb-2">Edit Format Details</h5>
            {/* <button onClick={() => console.log(reqData.selectedSubjectList.map(sub => sub.sub_id).join(','))} role="button" type="button">Show data</button> */}
            <Card>
              {/* <AddDeleteTableRows /> */}
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <p>Number Of Questions : {totalQues}</p>
                  {/* <p>Number Of Questions : {reqData.total_questions}</p> */}
                  <p>Total marks : {totalMarks}</p>
                </div>
                <SecBTN
                  className={classes["add-row"]}
                  onClick={addTableRows}
                  type="button"
                >
                  Add New Row
                </SecBTN>
              </div>
              <div className={`table-responsive ${classes.table}`}>
                <table className="table table-bordered align-middle">
                  <thead>
                    <tr>
                      <th>Subject</th>
                      <th>Section</th>
                      <th>Type</th>
                      <th>No. Of Questions</th>
                      <th>Attempt Question</th>
                      <th>+ve Marks</th>
                      <th>-ve Marks</th>
                      <th>Partial Marks</th>
                      <th>Add Image</th>
                      <th>Delete Row</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reqData.details.map((data, index) => {
                      const {
                        sub_id,
                        section_id,
                        type_id,
                        num_questions,
                        attempt_question,
                        positive_marks,
                        negative_marks,
                        partial_marks,
                        section_instruction,
                      } = data;
                      return (
                        <tr key={section_id + id + index}>
                          <td>
                            <Select
                              className={
                                sub_id !== ""
                                  ? classes.select
                                  : classes.disabled
                              }
                              onChange={(evnt) => handleRowChange(index, evnt)}
                              name="sub_id"
                              required
                              value={sub_id}
                            >
                              <option value="" disabled>
                                Select Subject
                              </option>
                              {subList.map((sub) => {
                                return (
                                  <option
                                    key={id + sub.sub_id + sub.sub_name}
                                    value={sub.sub_id}
                                  >
                                    {sub.sub_name}
                                  </option>
                                );
                              })}
                              <option value="Chemistry">Chemistry</option>
                              <option value="Maths">Maths</option>
                            </Select>
                          </td>
                          <td>
                            <Select
                              className={
                                section_id !== ""
                                  ? classes.select
                                  : classes.disabled
                              }
                              required
                              onChange={(evnt) => handleRowChange(index, evnt)}
                              name="section_id"
                              value={section_id}
                            >
                              <option value="" disabled>
                                Select Section
                              </option>
                              {dataList.section.map((sec) => {
                                return (
                                  <option
                                    key={sec.section_id + id + sec.section_name}
                                    value={sec.section_id}
                                  >
                                    {sec.section_name}
                                  </option>
                                );
                              })}
                            </Select>
                          </td>
                          <td>
                            <Select
                              className={
                                type_id !== ""
                                  ? classes.select
                                  : classes.disabled
                              }
                              required
                              onChange={(evnt) => handleRowChange(index, evnt)}
                              name="type_id"
                              value={type_id}
                            >
                              <option value="" disabled>
                                Select Type
                              </option>
                              {dataList.questiontype.map((type) => {
                                return (
                                  <option
                                    key={type.type_id + id + type.type}
                                    value={type.type_id}
                                  >
                                    {type.type}
                                  </option>
                                );
                              })}
                            </Select>
                          </td>
                          <td>
                            <Input
                              className={classes.input}
                              placeholder="Enter No.of Questions"
                              type="number"
                              required
                              value={num_questions}
                              onChange={(evnt) => handleRowChange(index, evnt)}
                              name="num_questions"
                            />
                          </td>
                          <td>
                            <Input
                              className={classes.input}
                              placeholder="Enter Attempt Question"
                              type="number"
                              value={attempt_question || ''}
                              onChange={(evnt) => handleRowChange(index, evnt)}
                              name="attempt_question"
                            />
                          </td>
                          <td>
                            <Input
                              className={classes.input}
                              placeholder="Enter +ve Marks"
                              type="number"
                              value={positive_marks}
                              onChange={(evnt) => handleRowChange(index, evnt)}
                              name="positive_marks"
                              required
                            />
                          </td>
                          <td>
                            <Input
                              className={classes.input}
                              placeholder="Enter -ve Marks"
                              type="number"
                              value={negative_marks}
                              onChange={(evnt) => handleRowChange(index, evnt)}
                              name="negative_marks"
                              required
                            />
                          </td>
                          <td>
                            <Input
                              className={classes.input}
                              placeholder="Partial Marks"
                              type="number"
                              value={partial_marks}
                              onChange={(evnt) => handleRowChange(index, evnt)}
                              name="partial_marks"
                              required
                            />
                          </td>
                          <td className="text-center">
                            {/* <SecBTN
                            className={classes["sec-btn"]}
                            onClick={() =>
                              getFileList("section_instruction", index)
                            }
                          >
                            <i className="bx bx-plus"></i>
                          </SecBTN>
                          <p className={classes["add-img"]}>Add Image</p> */}
                            {/*  */}
                            {isEmpty(section_instruction) ? (
                              <>
                                <SecBTN
                                  className={classes["sec-btn"]}
                                  onClick={() =>
                                    handleImageUpload("section_instruction", index)
                                  }
                                  type="button"
                                >
                                  <i className="bx bx-plus"></i>
                                </SecBTN>
                                <p>Add Image</p>
                              </>
                            ) : (
                              <div className="text-center">
                                <div className={classes.instructionsImg}>
                                  <img src={section_instruction} />
                                  <i
                                    className="fa-solid fa-xmark"
                                    onClick={() => {
                                      const rowsInput = [...reqData.details];
                                      rowsInput[index]["section_instruction"] =
                                        "";
                                      setReqData((prev) => {
                                        return {
                                          ...prev,
                                          details: rowsInput,
                                        };
                                      });
                                    }}
                                  ></i>
                                </div>
                              </div>
                            )}
                            {/*  */}
                          </td>
                          <td className="text-center">
                            {index !== 0 && (
                              <SecBTN
                                className={classes["dlt-row"]}
                                onClick={() => deleteTableRows(index)}
                                type="button"
                              >
                                x
                              </SecBTN>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </Card>
          </Graybg>
          <div className="text-end mt-3">
            {/* <SecBTN className={classes["cancel-btn"]}>Cancel Changes</SecBTN> */}
            <SecBTN
              className={classes["save-btn"]}
              type="submit"
              onClick={() => {
                console.log(form.current.length, form.current);
                for (let i = 0; i < form.current.length; i++) {
                  if (
                    form.current[i].required === true &&
                    form.current[i].value === ""
                  ) {
                    form.current[i].style.border = "1px solid red";
                  } else if (
                    form.current[i].required === true &&
                    form.current[i].value !== ""
                  ) {
                    form.current[i].style.border = "none";
                  }
                }
              }}
            >
              Save Changes
            </SecBTN>
          </div>
        </form>
      </div>
    </>
  );
};

export default React.memo(FormatEdit);

  